import { faEnvelope, faNoteSticky, faPaperPlane, faPills } from '@fortawesome/free-solid-svg-icons';

export const TaskTypeEnum = {
  REFERRAL: {
    value: "REFERRAL",
    description: 'Referral Task',
    color: 'rgb(255, 230, 230)',
    icon: faPaperPlane,
  },
  ADMIN_NOTE: {
    value: "ADMIN_NOTE",
    description: 'Administrative Note',
    color: 'rgb(230, 255, 230)',
    icon: faNoteSticky,
  },
  PRESCRIPTION_CHANGE: {
    value: "PRESCRIPTION_CHANGE",
    description: 'Prescription Change',
    color: 'rgb(255, 240, 200)',
    icon: faPills,
  },
  PATIENT_NOTE: {
    value: "PATIENT_NOTE",
    description: 'Patient Message',
    color: 'rgb(230, 230, 255)',
    icon: faEnvelope,
  },
  // Add more task types as needed
};
